<template>
  <div class="home">
    <swiper @wow="wow" class="hidden-xs-only" />
    <smallSwiper @wow="wow" class="hidden-sm-and-up" />
    <about />
    <strength />
    <Product />
    <Service />
<!--    <News />-->
    
  </div>
</template>

<script>
// @ is an alias to /src
import Swiper from './Swiper/Swiper.vue'
import smallSwiper from './Swiper/smallSwiper.vue'
import About from './About/About.vue'
import strength from './Strength/strength.vue'
import Product from './Product/product.vue'
import Service from './Service/Service.vue'
import News from './News/News.vue'
import {WOW} from 'wowjs'
import Scrollbar from 'smooth-scrollbar';

export default {
  name: 'home',
  components: {
    Swiper,
    smallSwiper,
    About,
    strength,
    Product,
    Service,
    News
  },
  data(){
    return{
      scrollbar: ''
    }
  },
  methods: {
    wow(){
      let wow=new WOW({offset:200})
      wow.init()
      this.scrollbar.addListener((status) => {
        wow.scrollHandler()
      });
    }
  },
  mounted(){
    
    //Scrollbar.initAll();
    this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
    window.pageYOffset=this.scrollbar.scrollTop
    this.scrollbar.addListener((status) => {
      window.pageYOffset=this.scrollbar.scrollTop
    });
  }
}
</script>


